import Button from "@mui/material/Button";
import { useEffect, useState } from "react";
import { useNitroStore } from "../../../store/Store";

interface SideLabelProps {
  type: string;
  onAdd: () => void;
}

const SideLabel: React.FC<SideLabelProps> = ({ type, onAdd }) => {
  const [currentFilters] = useNitroStore((state) => [state.currentFilters]);
  const isCompetitor = type === "Competitor Origins";
  const [isSearching, setIsSearching] = useState(false);
  useEffect(() => {
    if (
      currentFilters.city ||
      currentFilters.location ||
      currentFilters.party
    ) {
      setIsSearching(true);
    } else {
      setIsSearching(false);
    }
  }, [currentFilters]);
  return (
    <div
      className="origin-label"
      style={{ backgroundColor: isSearching ? "#f1f5f9" : "#FFFFFF" }}
    >
      <div className="side-label">
        <span
          data-testid="dot-icon"
          className="dot-icon"
          style={{
            backgroundColor: isCompetitor ? "#B91C1C" : "#1D4ED8",
          }}
        />
        <span
          className={`label-text ${
            isCompetitor ? "competitor-color" : "koch-color"
          }`}
        >
          {type}
        </span>
      </div>
      <Button
        id="add-origin-button"
        type="button"
        className="add-link"
        sx={{
          color: isCompetitor ? "#B91C1C" : "#1D4ED8",
          fontWeight: "bold",
          backgroundColor: "transparent",
          "&:hover": {
            backgroundColor: isCompetitor ? "#FEE2E2" : "#DBEAFE",
            transition: "background-color 0.2s ease",
          },
        }}
        disableRipple
        onClick={onAdd}
      >
        + ADD
      </Button>
    </div>
  );
};

export default SideLabel;
